interface Pillar {
  icon: string;
  title: string;
  subtitle: string;
  mechanism: string;
  deliverables: string[];
  exampleType: string;
}

const pillars: Pillar[] = [
  {
    icon: 'ri-align-center',
    title: '口径治理',
    subtitle: '统一数据口径',
    mechanism: '按业务类型（9810/0110/1039）统一归集口径与字段标准',
    deliverables: [
      '口径说明',
      '字段缺失清单',
      '批次归集规则',
    ],
    exampleType: '缺资料清单',
  },
  {
    icon: 'ri-shield-check-line',
    title: '流程治理',
    subtitle: '提交前校验与复盘',
    mechanism: '提交前校验缺项/异常，退单原因记录可复盘',
    deliverables: [
      '校验报告',
      '退单原因记录',
      '处理历史',
    ],
    exampleType: '校验报告',
  },
  {
    icon: 'ri-archive-line',
    title: '证据治理',
    subtitle: '单证目录化归档',
    mechanism: '按票/批次/主体归档，版本管理与目录结构清晰',
    deliverables: [
      '归档包目录',
      '材料下载导出',
      '留存策略说明',
    ],
    exampleType: '归档包目录',
  },
  {
    icon: 'ri-user-settings-line',
    title: '责任治理',
    subtitle: '权限与留痕',
    mechanism: '角色权限（管理员/财务/关务/只读），关键操作留痕',
    deliverables: [
      '操作日志',
      '导出记录',
      '权限变更记录',
    ],
    exampleType: '操作留痕',
  },
];

interface GovernancePillarsProps {
  onViewExample: (exampleType: string) => void;
}

export default function GovernancePillars({ onViewExample }: GovernancePillarsProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* 标题 */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            治理四大支柱
          </h2>
          <p className="text-lg text-gray-600">
            把"口径与证据链"做成系统能力
          </p>
        </div>

        {/* 2×2 大卡网格 */}
        <div className="grid md:grid-cols-2 gap-8">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border-2 border-gray-200 p-8 hover:border-teal-200 hover:shadow-lg transition-all"
            >
              {/* 图标与标题 */}
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-teal-100 flex-shrink-0">
                  <i className={`${pillar.icon} text-2xl text-teal-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {pillar.subtitle}
                  </p>
                </div>
              </div>

              {/* 机制说明 */}
              <div className="mb-6">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                  机制
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {pillar.mechanism}
                </p>
              </div>

              {/* 交付物列表 */}
              <div className="mb-6">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
                  交付物
                </p>
                <ul className="space-y-2">
                  {pillar.deliverables.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-teal-50">
                        <i className="ri-check-line text-xs text-teal-600"></i>
                      </div>
                      <span className="text-sm text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* 查看示例链接 */}
              <button
                onClick={() => onViewExample(pillar.exampleType)}
                className="text-teal-600 text-sm font-medium hover:text-teal-700 underline cursor-pointer"
              >
                查看示例（{pillar.exampleType}）
              </button>
            </div>
          ))}
        </div>

        {/* 底部说明 */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            交付物以产品版本与合同约定为准
          </p>
        </div>
      </div>
    </section>
  );
}